{
  "name": "vaki",
  "version": "5.43.1",
  "license": "MIT",
  "browserslist": [
    "> 0.5%",
    "last 2 versions",
    "Firefox ESR",
    "not dead",
    "not IE 11"
  ],
  "scripts": {
    "test:local": "node tools/scripts/run-tests.js --affected",
    "test:ci": "bash tools/scripts/ci-test.sh --affected",
    "test:bigquery": "node tools/scripts/run-tests.js --bigquery",
    "test:bigquery:ci": "bash tools/scripts/ci-test.sh --beargquery --coverage",
    "test:tools": "node --test tools/scripts/*.test.js tools/scripts/lib/*.test.js tools/vakilorians/*/tests/*.test.js",
    "test:public": "node --test public/routes/*.test.js",
    "test:functions": "node tools/scripts/run-tests.js --functions",
    "test:functions:coverage": "cd functions && npm test -- --coverage",
    "test:reports-guard": "npm --prefix functions run build && firebase emulators:exec --only functions,firestore,auth \"node tools/vakilorians/reports-guard/probe.mjs\"",
    "test:rules": "firebase emulators:exec --only firestore \"vitest run --config firestore-tests/vitest.config.ts\"",
    "test:all": "node tools/scripts/run-tests.js --all --coverage",
    "serve:vaki:all": "nx run-many --target=serve --projects=vakers-vaki-web,admin-web-dashboard --parallel",
    "serve:vaki:all:stg": "nx run-many --target=serve --configuration=staging --projects=vakers-vaki-web,admin-web-dashboard --parallel",
    "serve:foundation:all": "npm run foundation:usa:build && npm run foundation:colombia:build && nx run-many --target=serve --projects=foundation-colombia,foundation-usa --parallel",
    "build": "npm run vaki-web:build:dev && npm run admin:build:dev && npm run vaki-link:build && npm run public-api:build:stg && npm run functions:build:dev",
    "affected": "nx affected",
    "admin:build:dev": "npm run script:models && nx build --project=admin-web-dashboard --configuration=development",
    "admin:build:prod": "npm run script:models && nx build --project=admin-web-dashboard --configuration=production",
    "admin:build:stg": "npm run script:models && nx build --project=admin-web-dashboard --configuration=staging",
    "admin:start:stg": "npm run script:models && npm run admin:build:stg && nx run admin-web-dashboard:serve:staging --port=4201",
    "admin:start": "npm run script:models && npm run admin:build:stg && nx run admin-web-dashboard:serve:development --port=4201",
    "admin:deploy:dev": "firebase use dev && firebase deploy --only hosting:admin-web",
    "admin:deploy:prod": "firebase use prod && firebase deploy --only hosting:admin-web",
    "bq-mcp:deploy": "bash tools/vakilorians/bigquery-mcp/deploy.sh",
    "slack-bridge:deploy": "bash tools/vakilorians/slack-bridge/scripts/deploy.sh",
    "slack-bridge:deploy:apply": "bash tools/vakilorians/slack-bridge/scripts/deploy.sh --apply",
    "affected:apps": "nx affected:apps",
    "affected:build": "nx affected:build",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected:e2e": "nx affected:e2e",
    "affected:libs": "nx affected:libs",
    "affected:lint": "nx affected:lint",
    "affected:test": "nx affected:test",
    "dead-code": "node tools/scripts/dead-code-check.js",
    "clean:build": "rm -rf dist && cd public && rm -rf dist && cd ..",
    "clean:cache": "npm cache clean --force && rm -rf node_modules package-lock.json .angular && cd functions && rm -rf node_modules package-lock.json && cd .. && cd public && rm -rf node_modules package-lock.json && cd ..",
    "clean": "npm run clean:cache && npm run clean:build && npm i && npx nx reset",
    "dep-graph": "nx dep-graph",
    "e2e:browser:chrome": "nx run vakers-vaki-web-e2e:e2e:staging --browser chrome --no-exit",
    "e2e:ci": "npm run script:models && nx run vakers-vaki-web-e2e:e2e:staging --headless --record --key=$npm_config_key",
    "e2e:config": "node tools/scripts/generate-cypress-config.js",
    "e2e:local": "nx run vakers-vaki-web-e2e:e2e:es --headless",
    "e2e": "npm run e2e:config && npm run script:models && nx run vakers-vaki-web-e2e:e2e:es --headless",
    "functions:env:pull": "bash tools/scripts/env-pull.sh \".env.vaquinha-dev\" \"vaki-web staging\" functions/.env.vaquinha-dev",
    "functions:env:pull:prod": "bash tools/scripts/env-pull.sh \".env.vaquinha-a55b7\" \"vaki-web-prod\" functions/.env.vaquinha-a55b7",
    "functions:env:push": "node tools/scripts/functions-env-push.js --env=dev",
    "functions:env:push:prod": "node tools/scripts/functions-env-push.js --env=prod",
    "functions:env:push:dry": "node tools/scripts/functions-env-push.js --env=dev --dry-run",
    "functions:env:sync": "node tools/scripts/env-sync.js --target=functions/.env.vaquinha-dev",
    "functions:env:sync:prod": "node tools/scripts/env-sync.js --target=functions/.env.vaquinha-a55b7",
    "emulators:kill": "{ lsof -ti :4000; lsof -ti :5001; lsof -ti :8080; lsof -ti :9099; lsof -ti :9199; } 2>/dev/null | sort -u | xargs kill -9 2>/dev/null || true",
    "emulators:start": "cd functions && npm run build:watch | firebase emulators:start --import ./../.firebase/emulators-data --export-on-exit",
    "dev:tunnel": "zrok2 share public http://127.0.0.1:5001 --name-selection public:vaki-dev",
    "dev:web3": "bash tools/scripts/tmux/dev-web3.sh",
    "villa:stop": "pkill -f 'astro dev' ; pkill -f 'firebase.*emulators' ; pkill -f 'fake-vaki-api' ; echo 'villa: stopped'",
    "villa:dev": "node apps/foundation/villa/scripts/dev.mjs",
    "villa:dev:fund": "node apps/foundation/villa/scripts/dev.mjs --fund",
    "villa:preview": "node apps/foundation/villa/scripts/dev.mjs --preview --fund",
    "villa:preview:real": "node apps/foundation/villa/scripts/dev.mjs --preview --real-fund",
    "firebase:start:functions": "cd functions && npm run build:watch && cd .. && firebase emulators:start --only functions",
    "format:check": "nx format:check",
    "format:write": "nx format:write",
    "functions:build:dev": "cd functions && npm run build && cd ../",
    "functions:build:prod": "cd functions && npm run build && cd ../",
    "functions:install": "cd functions && npm ci && cd ..",
    "functions:list": "node tools/scripts/deploy-affected-functions.js --list",
    "functions:help": "node tools/scripts/deploy-affected-functions.js --help",
    "functions:deploy:dev": "node tools/scripts/deploy-affected-functions.js --env=dev",
    "functions:deploy:stg": "node tools/scripts/deploy-affected-functions.js --env=dev",
    "functions:deploy:prod": "node tools/scripts/deploy-affected-functions.js --env=prod",
    "functions:deploy:dev:all": "node tools/scripts/deploy-affected-functions.js --all --env=dev",
    "functions:deploy:stg:all": "node tools/scripts/deploy-affected-functions.js --all --env=dev",
    "functions:deploy:prod:all": "node tools/scripts/deploy-affected-functions.js --all --env=prod",
    "functions:deploy:dev:dry": "node tools/scripts/deploy-affected-functions.js --env=dev --dry-run",
    "functions:deploy:stg:dry": "node tools/scripts/deploy-affected-functions.js --env=dev --dry-run",
    "functions:deploy:prod:dry": "node tools/scripts/deploy-affected-functions.js --env=prod --dry-run",
    "functions:deploy:dev:no-batch": "node tools/scripts/deploy-affected-functions.js --env=dev --no-smart-batching",
    "functions:deploy:prod:no-batch": "node tools/scripts/deploy-affected-functions.js --env=prod --no-smart-batching",
    "functions:deploy:affected": "node tools/scripts/deploy-affected-functions.js",
    "functions:deploy:affected:dry": "node tools/scripts/deploy-affected-functions.js --dry-run",
    "functions:deploy:all": "node tools/scripts/deploy-affected-functions.js --all",
    "gcloud:credential:dev": "export GOOGLE_APPLICATION_CREDENTIALS=\"/Users/ni500/.config/gcloud/vaquinha-dev-firebase-adminsdk-96o9p-473a4b37ed.json\"",
    "gcloud:credential:prod": "export GOOGLE_APPLICATION_CREDENTIALS=\"/Users/ni500/.config/gcloud/vaquinha-a55b7-firebase-adminsdk-1yv4r-11a117a2ba.json\"",
    "help": "nx help",
    "husky:install": "husky install",
    "i18n:en": "nx extract-i18n vakers-vaki-web --output-path libs/vakers/locale/util/src/lib --out-file messages.en.xlf",
    "i18n": "nx extract-i18n vakers-vaki-web --output-path libs/vakers/locale/util/src/lib",
    "i18n:merge": "python3 tools/scripts/i18n/merge-translations.py",
    "i18n:sync": "python3 tools/scripts/i18n/sync-translations.py",
    "i18n:translate": "python3 tools/scripts/i18n/translate-common-terms.py",
    "i18n:all": "npm run i18n && npm run i18n:merge && npm run i18n:sync && npm run i18n:translate",
    "lint:functions": "cd functions && npm run lint && cd ../",
    "lint": "nx run lint --fix && npm run script:models && nx affected:lint --fix && npx stylelint \"{apps,libs}/**/src/**/*.scss\" && npm run lint:functions",
    "ng": "nx",
    "nx": "nx",
    "postbuild": "npm run sentry:sourcemaps:upload && npm run sourcemap:move && npm run script:vakers-vaki-web",
    "format:package-json": "node tools/scripts/format-package-json.js",
    "postinstall": "npm run script:packages && npm run vaki-web:install:public-dendencies && npm run functions:install",
    "prepare": "npm run husky:install",
    "precommit": "npm run script:models",
    "prerender": "nx run vakers-vaki-web:prerender",
    "script:download-firestore": "node tools/scripts/query-builder.js",
    "script:models": "node tools/scripts/shared-models.js",
    "script:packages": "node tools/scripts/update-packages.js",
    "script:update-fields-firestore": "node tools/scripts/update-field-firestore/update-field-firestore.js",
    "script:vakers-vaki-web": "node tools/scripts/vakers-vaki-web.js",
    "sentry:sourcemaps:upload": "node tools/scripts/sentry-sourcemaps-upload.js",
    "script:siigo": "cd tools/scripts/siigo && npx ts-node convert-csv.ts && cd ../../",
    "sourcemap:vaki-web:main": "source-map-explorer dist/apps/vakers/vaki-web/browser/es/main-es2015.js",
    "sourcemap:vaki-web": "source-map-explorer dist/apps/vakers/vaki-web/browser/es/*.js",
    "sourcemap": "source-map-explorer public/dist/apps/vakers/vaki-web/server/es/*.js",
    "sourcemap:move": "rm -rf dist/apps/vakers/vaki-web/sourceMaps && mkdir -p dist/apps/vakers/vaki-web/sourceMaps && (mv dist/apps/vakers/vaki-web/server/es/*.map dist/apps/vakers/vaki-web/sourceMaps 2>/dev/null || true) && (mv dist/apps/vakers/vaki-web/server/en/*.map dist/apps/vakers/vaki-web/sourceMaps 2>/dev/null || true)",
    "storage:cors:dev": "gsutil cors set tools/storage-cors/dev-cors.json gs://vaquinha-dev.appspot.com",
    "test": "nx test",
    "update": "nx migrate latest",
    "version:tag": "node tools/scripts/get-version.js",
    "version:tag-date": "node tools/scripts/get-version.js --with-date",
    "sync:codeowners": "node .github/scripts/generate-codeowners.js",
    "version:current": "node -p \"'v' + require('./package.json').version\"",
    "version:bump": "node tools/scripts/version-bump.js",
    "version:bump:major": "npm run version:bump major",
    "version:bump:minor": "npm run version:bump minor",
    "version:bump:patch": "npm run version:bump patch",
    "version:bump:beta": "npm run version:bump beta",
    "release:prod": "npm run version:bump:patch && git add package.json package-lock.json && git commit -m \"chore(core): release v$(node -p \"require('./package.json').version\")\" && git tag v$(node -p \"require('./package.json').version\") && echo \"\\n✓ Release ready. Push with: git push origin main --tags\"",
    "release:train": "node tools/scripts/prod-release-train.js run",
    "release:train:dry": "node tools/scripts/prod-release-train.js run --dry-run",
    "release:beta": "npm run version:bump:beta && git add package.json package-lock.json && git commit -m \"chore(core): beta release v$(node -p \"require('./package.json').version\")\" && git tag v$(node -p \"require('./package.json').version\") && echo \"\\n✓ Beta release ready. Push with: git push origin main --tags\"",
    "vaki-link:build": "npm run script:models && nx run vakers-vaki-link:build:development",
    "vaki-link:build:stg": "npm run script:models && nx run vakers-vaki-link:build:staging",
    "vaki-link:build:prod": "npm run script:models && nx run vakers-vaki-link:build:production",
    "vaki-link:deploy:prod": "npm run vaki-link:build:prod && npm run vaki-link:prepare-deploy:prod && gcloud config set project vaquinha-a55b7 && gcloud run deploy vaki-link --source=dist/apps/vakers/vaki-link --region=us-central1 --service-account=firebase-adminsdk-1yv4r@vaquinha-a55b7.iam.gserviceaccount.com --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "vaki-link:deploy:stg": "npm run vaki-link:build:stg && npm run vaki-link:prepare-deploy:stg && gcloud config set project vaquinha-dev && gcloud run deploy vaki-link --source=dist/apps/vakers/vaki-link --region=us-central1 --service-account=firebase-adminsdk-96o9p@vaquinha-dev.iam.gserviceaccount.com --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "vaki-link:prepare-deploy:stg": "node tools/scripts/prepare-vaki-link-deploy.js staging",
    "vaki-link:prepare-deploy:prod": "node tools/scripts/prepare-vaki-link-deploy.js production",
    "vaki-link:start": "nx run vakers-vaki-link:serve:development",
    "vaki-link:start:stg": "nx run vakers-vaki-link:serve:staging",
    "public-api:build": "npm run script:models && nx run api-public-api:build",
    "public-api:build:stg": "npm run script:models && nx run api-public-api:build:staging",
    "public-api:build:prod": "npm run script:models && nx run api-public-api:build:production",
    "public-api:deploy:prod": "npm run public-api:build:prod && npm run public-api:prepare-deploy:prod && gcloud config set project vaquinha-a55b7 && gcloud run deploy public-api --source=dist/apps/api/public-api --region=us-central1 --platform=managed --allow-unauthenticated --service-account=firebase-adminsdk-1yv4r@vaquinha-a55b7.iam.gserviceaccount.com --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "public-api:deploy:stg": "npm run public-api:build:stg && npm run public-api:prepare-deploy:stg && gcloud config set project vaquinha-dev && gcloud run deploy public-api --source=dist/apps/api/public-api --region=us-central1 --platform=managed --allow-unauthenticated --service-account=firebase-adminsdk-96o9p@vaquinha-dev.iam.gserviceaccount.com --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "public-api:prepare-deploy:stg": "node tools/scripts/prepare-api-deploy.js staging",
    "public-api:prepare-deploy:prod": "node tools/scripts/prepare-api-deploy.js production",
    "public-api:start": "nx run api-public-api:serve",
    "vaki-web:build:dev": "npm run script:models && nx build --project=vakers-vaki-web --configuration=development  && npm run postbuild",
    "vaki-web:build:prod": "npm run script:models && nx build --project=vakers-vaki-web --configuration=production && npm run postbuild",
    "purge:vaki-web": "node tools/scripts/purge-css.js dist/apps/vakers/vaki-web/browser",
    "purge:vaki-web:dry": "node tools/scripts/purge-css.js dist/apps/vakers/vaki-web/browser --dry-run",
    "purge:admin": "node tools/scripts/purge-css.js dist/apps/admin/web-dashboard",
    "vaki-web:build:stg": "npm run script:models && nx build --project=vakers-vaki-web --configuration=staging && npm run postbuild",
    "vaki-web:deploy:prod": "npm run vaki-web:build:prod && gcloud config set project vaquinha-a55b7 && gcloud run deploy vaki-web --service-account=firebase-adminsdk-1yv4r@vaquinha-a55b7.iam.gserviceaccount.com --source=public --region=us-central1 --project vaquinha-a55b7 --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "vaki-web:deploy:stg": "npm run vaki-web:build:stg && gcloud config set project vaquinha-dev && gcloud run deploy vaki-web --service-account=firebase-adminsdk-96o9p@vaquinha-dev.iam.gserviceaccount.com --source=public --region=us-central1 --project vaquinha-dev --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "vaki-web:deploy:prod-beta": "npm run vaki-web:build:prod && gcloud config set project vaquinha-a55b7 && gcloud run deploy vaki-web3 --service-account=firebase-adminsdk-1yv4r@vaquinha-a55b7.iam.gserviceaccount.com --source=public --region=us-central1 --project vaquinha-a55b7 --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "vaki-web:deploy:stg-beta": "npm run vaki-web:build:stg && gcloud config set project vaquinha-dev && gcloud run deploy vaki-web3 --service-account=firebase-adminsdk-96o9p@vaquinha-dev.iam.gserviceaccount.com --source=public --region=us-central1 --project vaquinha-dev --tag=$(node tools/scripts/get-version.js) --revision-suffix=$(node tools/scripts/get-version.js --with-date)",
    "vaki-web:start:en": "npm run script:models && nx serve --project=vakers-vaki-web --configuration=en --port 4202",
    "vaki-web:start:en-stg": "npm run script:models && nx serve --project=vakers-vaki-web --configuration=en-stg --port 4202",
    "vaki-web:start:prod": "npm run script:models && nx serve --project=vakers-vaki-web --configuration=production",
    "vaki-web:start:stg": "npm run script:models && nx serve --project=vakers-vaki-web --configuration=staging",
    "vaki-web:start:ssr": "npm run vaki-web:build:stg  && node --trace-warnings public/index.js",
    "vaki-web:start": "npm run script:models && nx serve --project=vakers-vaki-web --configuration=development",
    "vaki-web:install:public-dendencies": "cd public && npm i && cd ..",
    "foundation:usa:dev": "nx serve foundation-usa",
    "foundation:usa:build": "nx build foundation-usa",
    "foundation:usa:build:stg": "nx build foundation-usa --configuration=staging",
    "foundation:usa:build:prod": "nx build foundation-usa --configuration=production",
    "foundation:usa:preview": "nx preview foundation-usa",
    "foundation:usa:deploy:stg": "npm run foundation:usa:build:stg && firebase use dev && firebase deploy --only hosting:vaki-foundation",
    "foundation:usa:deploy:prod": "npm run foundation:usa:build:prod && firebase use prod && firebase deploy --only hosting:vaki-foundation",
    "foundation:colombia:dev": "nx serve foundation-colombia",
    "foundation:colombia:build": "nx build foundation-colombia",
    "foundation:colombia:build:stg": "nx build foundation-colombia --configuration=staging",
    "foundation:colombia:build:prod": "nx build foundation-colombia --configuration=production",
    "foundation:colombia:preview": "nx preview foundation-colombia",
    "foundation:colombia:deploy:stg": "npm run foundation:colombia:build:stg && firebase use dev && firebase deploy --only hosting:fundacion-vaki",
    "foundation:colombia:deploy:prod": "npm run foundation:colombia:build:prod && firebase use prod && firebase deploy --only hosting:fundacion-vaki",
    "checkout-web:dev": "nx serve vakers-checkout-web",
    "checkout-web:build": "nx build vakers-checkout-web",
    "checkout-web:build:stg": "nx build vakers-checkout-web --configuration=staging",
    "checkout-web:build:prod": "nx build vakers-checkout-web --configuration=production",
    "checkout-web:preview": "nx preview vakers-checkout-web",
    "checkout-web:check": "nx run vakers-checkout-web:check",
    "checkout-web:deploy:stg": "npm run checkout-web:build:stg && firebase use dev && firebase deploy --only hosting:checkout-web",
    "checkout-web:deploy:prod": "npm run checkout-web:build:prod && firebase use prod && firebase deploy --only hosting:checkout-web",
    "api-docs:build:stg": "nx build api-api-docs --configuration=staging",
    "api-docs:build:prod": "nx build api-api-docs --configuration=production",
    "api-docs:deploy:stg": "npm run api-docs:build:stg && firebase use dev && firebase deploy --only hosting:api-docs",
    "api-docs:deploy:prod": "npm run api-docs:build:prod && firebase use prod && firebase deploy --only hosting:api-docs",
    "web3:check-treasury": "node tools/web3/check-treasury.js",
    "web3:check-treasury:dev": "node tools/web3/check-treasury.js --env=dev",
    "web3:check-treasury:prod": "node tools/web3/check-treasury.js --env=prod",
    "web3:check-all-treasuries": "node tools/web3/check-all-treasuries.js",
    "web3:check-all-treasuries:dev": "node tools/web3/check-all-treasuries.js --env=dev",
    "web3:check-all-treasuries:prod": "node tools/web3/check-all-treasuries.js --env=prod",
    "web3:recovery-harness": "vite --config tools/web3/recovery/harness/vite.config.ts",
    "playwright:e2e": "nx run-many -t e2e -p vakers-vaki-web-playwright admin-web-dashboard-playwright",
    "playwright:e2e:vaki": "nx run vakers-vaki-web-playwright:e2e",
    "playwright:e2e:admin": "nx run admin-web-dashboard-playwright:e2e",
    "playwright:e2e:local": "nx run vakers-vaki-web-playwright:e2e:local",
    "playwright:e2e:staging": "nx run vakers-vaki-web-playwright:e2e:staging",
    "playwright:ui": "nx run vakers-vaki-web-playwright:e2e:ui",
    "playwright:ui:admin": "nx run admin-web-dashboard-playwright:e2e:ui",
    "playwright:report": "nx run vakers-vaki-web-playwright:show-report",
    "playwright:e2e:local:basic-flow": "nx run vakers-vaki-web-playwright:e2e:local:basic-flow",
    "playwright:e2e:local:happy-path-1": "nx run vakers-vaki-web-playwright:e2e:local:happy-path-1",
    "playwright:e2e:local:happy-path-2": "nx run vakers-vaki-web-playwright:e2e:local:happy-path-2",
    "playwright:e2e:local:happy-path-3": "nx run vakers-vaki-web-playwright:e2e:local:happy-path-3",
    "playwright:e2e:local:happy-path-4": "nx run vakers-vaki-web-playwright:e2e:local:happy-path-4",
    "playwright:e2e:local:guest-donation": "nx run vakers-vaki-web-playwright:e2e:local:guest-donation",
    "playwright:e2e:local:donate-to-another-vaki": "nx run vakers-vaki-web-playwright:e2e:local:donate-to-another-vaki",
    "playwright:e2e:local:cobre-pse": "nx run vakers-vaki-web-playwright:e2e:local:cobre-pse",
    "playwright:e2e:staging:basic-flow": "nx run vakers-vaki-web-playwright:e2e:staging:basic-flow",
    "playwright:e2e:staging:happy-path-1": "nx run vakers-vaki-web-playwright:e2e:staging:happy-path-1",
    "playwright:e2e:staging:happy-path-2": "nx run vakers-vaki-web-playwright:e2e:staging:happy-path-2",
    "playwright:e2e:staging:happy-path-3": "nx run vakers-vaki-web-playwright:e2e:staging:happy-path-3",
    "playwright:e2e:staging:happy-path-4": "nx run vakers-vaki-web-playwright:e2e:staging:happy-path-4",
    "playwright:e2e:staging:guest-donation": "nx run vakers-vaki-web-playwright:e2e:staging:guest-donation",
    "playwright:e2e:staging:donate-to-another-vaki": "nx run vakers-vaki-web-playwright:e2e:staging:donate-to-another-vaki",
    "playwright:e2e:staging:cobre-pse": "nx run vakers-vaki-web-playwright:e2e:staging:cobre-pse",
    "creators:start": "nx serve creators-mobile",
    "creators:build": "nx build creators-mobile",
    "creators:sync": "npm run creators:build && cd apps/creators/mobile && npx cap sync",
    "creators:ios": "npm run creators:build && cd apps/creators/mobile && npx cap run ios",
    "creators:ios:open": "npm run creators:build && cd apps/creators/mobile && npx cap sync ios && npx cap open ios",
    "creators:android": "npm run creators:build && cd apps/creators/mobile && npx cap run android",
    "creators:android:open": "npm run creators:build && cd apps/creators/mobile && npx cap sync android && npx cap open android"
  },
  "private": true,
  "dependencies": {
    "@algolia/client-search": "^5.10.0",
    "@angular-architects/ngrx-toolkit": "^20.5.0",
    "@angular-eslint/builder": "^20.0.0",
    "@angular-eslint/schematics": "^20.0.0",
    "@angular/animations": "^20.3.15",
    "@angular/cdk": "^20.1.2",
    "@angular/common": "^20.3.15",
    "@angular/compiler": "^20.3.15",
    "@angular/core": "^20.3.15",
    "@angular/elements": "21.0.5",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "^20.3.15",
    "@angular/localize": "^20.3.15",
    "@angular/material": "^20.1.2",
    "@angular/platform-browser": "^20.3.15",
    "@angular/platform-browser-dynamic": "^20.3.15",
    "@angular/platform-server": "^20.3.15",
    "@angular/pwa": "21.0.3",
    "@angular/router": "^20.3.15",
    "@angular/service-worker": "^20.3.15",
    "@google-cloud/bigquery": "7.9.4",
    "@google-cloud/firestore": "^7.11.0",
    "@google-cloud/storage": "7.16.0",
    "@intercom/messenger-js-sdk": "^0.0.14",
    "@kolkov/angular-editor": "3.0.0-beta.2",
    "@mercadopago/sdk-js": "^0.0.3",
    "@nestjs/axios": "4.0.0",
    "@nestjs/common": "10.4.17",
    "@nestjs/config": "^4.0.2",
    "@nestjs/core": "10.4.17",
    "@nestjs/platform-express": "10.4.17",
    "@nestjs/swagger": "7.4.2",
    "@nestjs/throttler": "^6.4.0",
    "@ngrx/component-store": "20.1.0",
    "@ngrx/effects": "20.1.0",
    "@ngrx/entity": "20.1.0",
    "@ngrx/operators": "20.1.0",
    "@ngrx/router-store": "20.1.0",
    "@ngrx/signals": "20.1.0",
    "@ngrx/store": "20.1.0",
    "@nx/devkit": "22.3.0-beta.1",
    "@nx/plugin": "22.3.0-beta.1",
    "@privy-io/react-auth": "2.21.4",
    "@sendgrid/mail": "^8.1.3",
    "@sentry/angular": "^10.71.0",
    "@sentry/node": "^10.71.0",
    "@stripe/stripe-js": "^7.9.0",
    "@swc/helpers": "0.5.17",
    "@types/marked": "^5.0.2",
    "@types/react": "^18.3.12",
    "@types/react-dom": "^18.3.1",
    "@veriff/incontext-sdk": "^2.5.0",
    "@veriff/js-sdk": "^2.0.0",
    "axios": "^1.6.0",
    "buffer": "^6.0.3",
    "chart.js": "^4.4.6",
    "class-transformer": "^0.5.1",
    "class-validator": "^0.14.1",
    "compression": "^1.7.4",
    "core-js": "^3.29.0",
    "cross-fetch": "^3.1.5",
    "crypto-browserify": "^3.12.1",
    "ethers": "^6.13.4",
    "express": "^4.21.2",
    "firebase": "^11.10.0",
    "firebase-admin": "^13.6.0",
    "firebase-functions": "^6.0.1",
    "fs-extra": "^11.3.0",
    "html-to-image": "^1.8.5",
    "image-size": "^2.0.2",
    "intl": "^1.2.5",
    "jose": "^5.9.6",
    "js-yaml": "4.1.0",
    "json2csv": "^5.0.6",
    "lodash-es": "^4.17.21",
    "luxon": "^3.4.0",
    "marked": "^16.3.0",
    "md5": "^2.3.0",
    "mercadopago": "^2.4.0",
    "next": "^15.0.3",
    "ngx-cookie": "6.0.1",
    "ngx-material-timepicker": "13.1.1",
    "ngx-paypal": "^11.0.0",
    "ngx-quicklink": "0.4.7",
    "node-fetch": "^3.3.2",
    "ox": "0.6.12",
    "pdfmake": "^0.2.4",
    "permissionless": "0.2.54",
    "process": "^0.11.10",
    "pug": "^3.0.2",
    "qrcode": "^1.5.4",
    "react": "^18.3.1",
    "react-dom": "^18.3.1",
    "reflect-metadata": "^0.2.2",
    "request": "^2.88.2",
    "rxjs": "^7.8.0",
    "search-insights": "^2.16.0",
    "stream-browserify": "^3.0.0",
    "stripe": "18.0.0",
    "swiper": "^11.1.3",
    "tslib": "^2.3.0",
    "util": "^0.12.5",
    "uuid": "^11.1.0",
    "@capacitor/app": "^8.1.0",
    "@capacitor/browser": "^8.0.3",
    "@capacitor/core": "^8.4.0",
    "@capacitor/ios": "^8.4.0",
    "@capacitor/push-notifications": "^8.1.1",
    "@ionic/angular": "^8.8.9"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.2.0",
    "@analogjs/vitest-angular": "^2.2.0",
    "@angular-builders/custom-webpack": "^20.0.0",
    "@angular-devkit/build-angular": "^20.3.13",
    "@angular-devkit/core": "^20.3.13",
    "@angular-devkit/schematics": "^20.3.13",
    "@angular-eslint/eslint-plugin": "^20.0.0",
    "@angular-eslint/eslint-plugin-template": "^20.0.0",
    "@angular-eslint/template-parser": "^20.0.0",
    "@angular/build": "^20.3.13",
    "@angular/compiler-cli": "^20.3.15",
    "@angular/language-service": "^20.3.15",
    "@angular/ssr": "^20.3.13",
    "@astrojs/starlight": "^0.37.7",
    "@commitlint/cli": "^19.3.0",
    "@ethereumjs/common": "^4.4.0",
    "@ethereumjs/evm": "^3.1.0",
    "@ethereumjs/statemanager": "^2.3.0",
    "@ethereumjs/util": "^9.1.0",
    "@faker-js/faker": "^9.4.0",
    "@firebase/rules-unit-testing": "^4.0.1",
    "@nestjs/schematics": "11.0.9",
    "@nestjs/testing": "10.4.17",
    "@nx/angular": "^22.2.6",
    "@nx/cypress": "22.3.0-beta.1",
    "@nx/esbuild": "22.3.0-beta.1",
    "@nx/eslint": "22.3.0-beta.1",
    "@nx/eslint-plugin": "22.3.0-beta.1",
    "@nx/express": "22.3.0-beta.1",
    "@nx/js": "22.3.0-beta.1",
    "@nx/nest": "22.3.0-beta.1",
    "@nx/node": "22.3.0-beta.1",
    "@nx/vite": "22.3.0-beta.1",
    "@nx/vitest": "22.3.0-beta.1",
    "@nx/web": "22.3.0-beta.1",
    "@nx/webpack": "22.3.0-beta.1",
    "@nx/workspace": "22.3.0-beta.1",
    "@playwright/test": "^1.55.1",
    "@scalar/api-reference": "^1.65.1",
    "@schematics/angular": "^20.3.13",
    "@sentry/cli": "^3.6.2",
    "@svgr/webpack": "^8.0.1",
    "@swc-node/register": "1.10.10",
    "@swc/cli": "0.7.2",
    "@swc/core": "1.11.21",
    "@types/compression": "^1.7.2",
    "@types/core-js": "^2.5.5",
    "@types/estree": "^1.0.0",
    "@types/express": "5.0.1",
    "@types/fs-extra": "11.0.4",
    "@types/imagemin-jpegtran": "^5.0.4",
    "@types/intl": "^1.2.2",
    "@types/jasmine": "^5.1.9",
    "@types/js-yaml": "4.0.9",
    "@types/json2csv": "^5.0.3",
    "@types/lodash-es": "^4.17.4",
    "@types/md5": "^2.3.1",
    "@types/mercadopago-sdk-js": "^2.0.17",
    "@types/node": "22.14.1",
    "@types/node-fetch": "2.6.12",
    "@types/pdfmake": "^0.2.11",
    "@types/pug": "^2.0.5",
    "@types/sharp": "^0.31.1",
    "@types/stripe-v3": "^3.1.33",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "8.48.0",
    "@typescript-eslint/parser": "8.48.0",
    "@typescript-eslint/utils": "8.48.0",
    "@vitest/coverage-v8": "4.0.9",
    "@vitest/ui": "4.0.9",
    "astro": "^5.12.0",
    "concurrently": "^9.2.0",
    "cross-env": "^10.0.0",
    "cypress": "15.7.0",
    "cypress-file-upload": "^5.0.8",
    "dotenv": "16.5.0",
    "esbuild": "^0.19.2",
    "eslint": "8.57.1",
    "eslint-config-google": "^0.14.0",
    "eslint-config-prettier": "10.1.2",
    "eslint-plugin-cypress": "4.2.1",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-playwright": "^2.5.1",
    "firebase-admin": "^13.6.0",
    "firebase-functions-test": "^3.3.0",
    "googleapis": "^140.0.0",
    "husky": "^9.1.7",
    "jasmine-marbles": "~0.9.1",
    "jiti": "2.4.2",
    "jsdom": "~22.1.0",
    "jsonc-eslint-parser": "^2.1.0",
    "knip": "^5.85.0",
    "nx": "22.2.6",
    "playwright": "^1.55.1",
    "postcss-scss": "^4.0.9",
    "prettier": "3.5.3",
    "purgecss": "^7.0.2",
    "sharp": "^0.34.1",
    "source-map-explorer": "^2.5.3",
    "stylelint": "^16.18.0",
    "stylelint-config-standard": "^38.0.0",
    "stylelint-prettier": "^5.0.3",
    "stylelint-scss": "^6.11.1",
    "ts-node": "10.9.2",
    "tsconfig-paths": "4.2.0",
    "typescript": "5.9.3",
    "vite": "7.2.4",
    "vite-plugin-dts": "~4.5.0",
    "vitest": "4.0.9",
    "webpack-bundle-analyzer": "^4.5.0",
    "zone.js": "~0.15.0",
    "@capacitor/cli": "^8.4.0",
    "@nx/playwright": "22.3.0-beta.1"
  },
  "overrides": {
    "undici": "6.19.2",
    "eslint": "8.57.1"
  }
}
